 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import XHTML00_COVER from '@/components/xhtml/00_Cover'
 import XHTML03_COPYRIGHT from '@/components/xhtml/03_Copyright'
 import XHTMLLOVE_1 from '@/components/xhtml/love_1'
 import XHTML02_TITLE_PAGE from '@/components/xhtml/02_Title_Page'
 import XHTML01_FRONT_MATTER from '@/components/xhtml/01_Front_Matter'
 import XHTML04_DEDICATION from '@/components/xhtml/04_Dedication'
 import XHTML05_CONTENTS from '@/components/xhtml/05_Contents'
 import XHTML06_INTERVIEWS from '@/components/xhtml/06_Interviews'
 import XHTMLLOVE_2 from '@/components/xhtml/love_2'
 import XHTML07_ABBREVIATIONS from '@/components/xhtml/07_Abbreviations'
 import XHTML08_ACKNOWLEDGMENTS from '@/components/xhtml/08_Acknowledgments'
 import XHTML09_PREFACE from '@/components/xhtml/09_Preface'
 import XHTML10_1__INTRODUCTION from '@/components/xhtml/10_1__Introduction'
 import XHTML11_2__CONCEPTUAL_FRAMEWORK from '@/components/xhtml/11_2__Conceptual_Framework'
 import XHTML12_3__NO_HASTE__THE_1996_NATIONAL_D from '@/components/xhtml/12_3__No_Haste__The_1996_National_D'
 import XHTML13_4__ACTIVE_OPENING__EFFECTIVE_MAN from '@/components/xhtml/13_4__Active_Opening__Effective_Man'
 import XHTML14_5__ACTIVE_MANAGEMENT__EFFECTIVE from '@/components/xhtml/14_5__Active_Management__Effective'
 import XHTML15_6___PROSPER_AGAIN___THE_2008_201 from '@/components/xhtml/15_6___Prosper_Again___The_2008_201'
 import XHTML16_7__CONCLUSIONS from '@/components/xhtml/16_7__Conclusions'
 import XHTML17_APPENDIX__SOURCES_RELATED_TO_PUB from '@/components/xhtml/17_Appendix__Sources_Related_to_Pub'
 import XHTML18_NOTES from '@/components/xhtml/18_Notes'
 import XHTML19_REFERENCES from '@/components/xhtml/19_References'
 import XHTML20_INDEX from '@/components/xhtml/20_Index'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/xhtml/05_Contents",
 			"name" : "xhtml/05_Contents",
 			"component" : XHTML05_CONTENTS
 		},
 		{
 			"path" : "/xhtml/06_Interviews",
 			"name" : "xhtml/06_Interviews",
 			"component" : XHTML06_INTERVIEWS
 		},
 		{
 			"path" : "/xhtml/love_2",
 			"name" : "xhtml/love_2",
 			"component" : XHTMLLOVE_2
 		},
 		{
 			"path" : "/xhtml/07_Abbreviations",
 			"name" : "xhtml/07_Abbreviations",
 			"component" : XHTML07_ABBREVIATIONS
 		},
 		{
 			"path" : "/xhtml/08_Acknowledgments",
 			"name" : "xhtml/08_Acknowledgments",
 			"component" : XHTML08_ACKNOWLEDGMENTS
 		},
 		{
 			"path" : "/xhtml/09_Preface",
 			"name" : "xhtml/09_Preface",
 			"component" : XHTML09_PREFACE
 		},
 		{
 			"path" : "/xhtml/10_1__Introduction",
 			"name" : "xhtml/10_1__Introduction",
 			"component" : XHTML10_1__INTRODUCTION
 		},
 		{
 			"path" : "/xhtml/11_2__Conceptual_Framework",
 			"name" : "xhtml/11_2__Conceptual_Framework",
 			"component" : XHTML11_2__CONCEPTUAL_FRAMEWORK
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js